// © 2001-2015 INOVx Solutions, Inc.
// 114 Pacifica Suite 300, Irvine, CA 92618 USA
// All rights reserved.
//
// This software is confidential, proprietary and unpublished property of
// INOVx Solutions, Inc.  It may NOT be copied in part or in whole on any
// medium, either electronic or printed, without the express written consent
// of INOVx Solutions, Inc.

import * as Enumerations from '../../Enumerations/Enumerations';
import { WorkerAuthContext } from '../workers/workerAuth';
// ---- Inline types for the JSON config ----
export type QualityKey = "ultra" | "high" | "medium" | "low";
export type ModeKey = "ByTargetPx" | "ByFixedDistances";
export interface QualitySettings {
    Mode: ModeKey;
    CoverageScale: number;
    Region_Megabyte_Memory_Limit: number;
    Quality: QualityKey;
}
export interface QualityProfile {
    voxelMM: number[];
    distanceMaxByLod: number[];
}
export interface QualityConfig {
    settings: QualitySettings;
    profiles: Record<QualityKey, QualityProfile>;
}

/*
export interface DisplayPayload {
    meshes: { [s: number]: BABYLON.SerializedMesh; };
    geometries: { [s: string]: BABYLON.SerializedGeometry; };

    keys: string[];
    infos: any[];
    idsToMaster: any[];
    materialKeys: any[];
    extents: BABYLON.BoundingBox;
}
*/
export namespace GraphicData {

    export interface WebWorkerPageRequest {
        PageId: string;
        BlockId: string;
        DisplayListId: string;
        MetadataFileId?: string;
        LoadDataType?: string;
        LOD?: number;
        ContentDisplayPriority: number;
        SourceAssetSetId?: string;
        GeometryOwnershipRevision?: number;
        GeometryOwnershipEpoch?: number;
    }

    export interface WebWorkerDataRequest {
        PageId: string;
        BlockId: string;
        WebWorkerNumber: number;
        DisplayListId: string;
        MetadataFileId?: string;
        PageRequests?: WebWorkerPageRequest[];
        ProjectId: string;
        Url: string;
        OctreeUrl: string;
        DecoderUrl: string;
        Type: number;
        ActivatedNamedLists: any;
        AllNamedLists: any;
        UseDefaultMaterial: boolean;
        UseXRayMaterial: boolean;
        ContentDisplayPriority: number;
        DisplayGeneration?: number;
        SourceAssetSetId?: string;
        GeometryOwnershipRevision?: number;
        GeometryOwnershipEpoch?: number;
        AccessToken?: string | null;
        LoadDataType: string;
        LOD: number;
        AuthContext?: WorkerAuthContext;
    }

    export interface WebWorkerGraphicData {

        PageId: string;
        BlockId: string;
        WebWorkerNumber: number;
        DisplayGeneration?: number;
        SourceAssetSetId?: string;
        GeometryOwnershipRevision?: number;
        GeometryOwnershipEpoch?: number;
        LoadDataType: string;
        GraphicData: any;
        Type: number;
        ContentDisplayPriority: number;
        UseDefaultMaterial: boolean;
        UseXRayMaterial: boolean;
        WorkerTaskComplete?: boolean;
    }

    export interface CylinderInstanceTransform {
        PrimitiveType: "cylinder";
        ComplexityLevel: number;
        Position: GraphicData.Vector3D;
        Scaling: GraphicData.Vector3D;
        Rotation: GraphicData.Rotation;
    }

    export interface AssetInstancePayload {
        ObjectId: string;
        MaterialKey: string;
        MinExtents: GraphicData.Vector3D;
        MaxExtents: GraphicData.Vector3D;
        Instances: CylinderInstanceTransform[];
    }

    export interface CylinderInstanceTransform {
        PrimitiveType: "cylinder";
        ComplexityLevel: number;
        Position: GraphicData.Vector3D;
        Scaling: GraphicData.Vector3D;
        Rotation: GraphicData.Rotation;
    }

    export interface AssetInstancePayload {
        ObjectId: string;
        MaterialKey: string;
        MinExtents: GraphicData.Vector3D;
        MaxExtents: GraphicData.Vector3D;
        Instances: CylinderInstanceTransform[];
    }

    export class Octree {
        public data: any;

        public Octree(data: any) {

        }
    }

    export class Octant {
    }

    export class GraphicalDataResultsByPage {
        public data: any;
        public pageId: string;
        public blockId: string;

        public get DataLength(): number {
            return this.data.length;
        }

        public GraphicDataResult(index: number): GraphicData.GraphicalObject {
            return new GraphicData.GraphicalObject(this.data[index].data);
        }

        constructor(data: any, blockId: string, pageId: string) {
            this.data = data;
            this.blockId = blockId;
            this.pageId = pageId;
        }
    }

    export class GraphicalDataResults {
        public data: any;

        public get DataLength(): number {
            return this.data.GraphicObjects.length;
        }

        public GraphicDataResult(index: number): GraphicData.GraphicalObject {
            return new GraphicData.GraphicalObject(this.data.GraphicObjects[index]);
        }

        constructor(data: any) {
            this.data = data;
        }
    }
    export class GraphicalObject {
        private data: any;
        private jsonObj: any;
        public get Id(): string {
            return this.data.ID;
        }

        public get Type(): number {
            return this.data.Type; // AssetObject = 1, MarkedPoint = 2
        }

        public get MaterialId(): string {
            return this.data.AppearanceID;
        }

        public get OverrideMaterialId(): string {
            return this.data.OverrideAppearanceID;
        }

        public get MinExtents(): GraphicData.Vector3D {
            return this.data.MinExtents;
        }

        public get MaxExtents(): GraphicData.Vector3D {
            return this.data.MaxExtents;
        }

        public get Primitives(): any {
            if (!this.jsonObj) {
                var primitiveData = this.data.PrimitiveData;

                if (typeof primitiveData === 'string') {
                    if (primitiveData !== "") {
                        this.jsonObj = JSON.parse(primitiveData);
                    }
                }
                else if (primitiveData != null) {
                    this.jsonObj = primitiveData;
                }
            }

            return this.jsonObj;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Id == undefined ||
                this.MaterialId == undefined ||
                this.MinExtents == undefined ||
                this.MaxExtents == undefined ||
                this.Primitives == undefined) {
                throw new TypeError();
            }
        }
    }
    export interface IExtents {
    }
    export interface IPrimitive {
        Ty: number;
    }

    export class Cylinder {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Rotation(): GraphicData.Rotation {
            return this.data.Rot;
        }

        public get Radius(): number {
            return this.data.Ra;
        }

        public get Length(): number {
            return this.data.Lgth;
        }

        public get Capped(): boolean {
            return this.data.Cpd;
        }

        public get Type(): number {
            return this.data.Ty;
        }
        public validate() {
            if (this.Position == undefined ||
                this.Rotation == undefined ||
                this.Radius == undefined ||
                this.Length == undefined ||
                this.Capped == undefined) {
                throw new TypeError();
            }
        }
        constructor(data: any) {
            this.data = data;
        }
    }

    export class Dish {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Rotation(): GraphicData.Rotation {
            return this.data.Rot;
        }

        public get Radius(): number {
            return this.data.Ra;
        }

        public get Height(): number {
            return this.data.Hgt;
        }

        public get Type(): number {
            return this.data.Ty;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Position == undefined ||
                this.Rotation == undefined ||
                this.Radius == undefined ||
                this.Height == undefined) {
                throw new TypeError();
            }
        }
    }
    export class Box {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }
        public get Rotation(): GraphicData.Rotation {
            return this.data.Rot;
        }

        public get Scale(): GraphicData.Vector3D {
            return this.data.Scl;
        }

        public get Type(): number {
            return this.data.Ty;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Position == undefined ||
                this.Rotation == undefined ||
                this.Scale == undefined) {
                throw new TypeError();
            }
        }
    }
    export class Cone {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Rotation(): GraphicData.Rotation {
            return this.data.Rot;
        }

        public get StartRadius(): number {
            return this.data.StRa;
        }

        public get EndRadius(): number {
            return this.data.EnRa;
        }

        public get Offset(): number {
            return this.data.Ofst;
        }

        public get Height(): number {
            return this.data.Hgt;
        }

        public get Capped(): boolean {
            return this.data.Cpd;
        }

        public get Type(): number {
            return this.data.Ty;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Position == undefined ||
                this.Rotation == undefined ||
                this.StartRadius == undefined ||
                this.EndRadius == undefined ||
                this.Offset == undefined ||
                this.Height == undefined ||
                this.Capped == undefined) {
                throw new TypeError();
            }
        }
    }

    export class Extrusion {
        private data: any;

        public get Clockwise(): boolean {
            return this.data.ClWi;
        }

        public get Capped(): boolean {
            return this.data.Cpd;
        }

        public get FlatShaded(): boolean {
            return this.data.FlSh;
        }

        public get NumCurves(): any {
            return this.data.Crvs.length;
        }

        public GetCurve(index: number): Curve {
            return (this.data.Crvs[index].Ty == 1) ? new PolylineCurve(this.data.Crvs[index]) : new EllipseCurve(this.data.Crvs[index]);
        }

        public get Path(): GraphicData.Vector3D[] {
            return this.data.Pa;
        }

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Rotation(): GraphicData.Rotation {
            return this.data.Rot;
        }

        public get UpVector(): GraphicData.Vector3D {
            return this.data.Up;
        }

        public get Scale(): GraphicData.Vector2D {
            return this.data.Scl;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Clockwise == undefined || this.Path == undefined ||
                this.Position == undefined || this.Rotation == undefined ||
                this.UpVector == undefined || this.NumCurves == undefined ||
                this.FlatShaded == undefined || this.Capped == undefined ||
                this.Scale == undefined) {
                throw new TypeError();
            }
        }
    }

    export class Sphere {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Radius(): number {
            return this.data.Ra;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Position == undefined ||
                this.Radius == undefined) {
                throw new TypeError();
            }
        }
    }
    export class IShape {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Rotation(): GraphicData.Rotation {
            return this.data.Rot;
        }

        public get Scale(): GraphicData.Vector3D {
            return this.data.Scl;
        }

        public get EndThickness(): number {
            return this.data.FlTh;
        }

        public get CenterThickness(): number {
            return this.data.WbTh;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Position == undefined ||
                this.Rotation == undefined ||
                this.Scale == undefined ||
                this.EndThickness == undefined ||
                this.CenterThickness == undefined) {
                throw new TypeError();
            }
        }
    }
    export class LShape {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Rotation(): GraphicData.Rotation {
            return this.data.Rot;
        }

        public get Scale(): GraphicData.Vector3D {
            return this.data.Scl;
        }

        public get Thickness(): number {
            return this.data.Th;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Position == undefined ||
                this.Rotation == undefined ||
                this.Scale == undefined ||
                this.Thickness == undefined) {
                throw new TypeError();
            }
        }
    }
    export class PolygonCollection {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Vertices(): GraphicData.Vector3D[] {
            return this.data.Vrt;
        }

        public get Indices(): number[] {
            return this.data.Ind;
        }

        public get Solid(): boolean {
            return this.data.Sol;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Position == undefined ||
                this.Vertices == undefined ||
                this.Indices == undefined ||
                this.Solid == undefined) {
                throw new TypeError();
            }
        }
    }
    export class Shell {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Vertices(): GraphicData.Vector3D[] {
            return this.data.Vrt;
        }

        public get Indices(): number[] {
            return this.data.Ind;
        }

        public get Colors(): number[] {
            return this.data.Col;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Position == undefined ||
                this.Vertices == undefined ||
                this.Indices == undefined) { 

                throw new TypeError();
            }
        }
    }

    export class Curve {
    }

    export class EllipseCurve extends Curve {
        private data: any;

        public get XCenter(): number {
            return this.data.XCtr;
        }

        public get YCenter(): number {
            return this.data.YCtr;
        }

        public get StartAngle(): number {
            return this.data.StAn;
        }

        public get EndAngle(): number {
            return this.data.EnAn;
        }

        public get XRadius(): number {
            return this.data.XRad;
        }

        public get YRadius(): number {
            return this.data.YRad;
        }

        public get Clockwise(): number {
            return this.data.ClWi;
        }

        constructor(data: any) {
            super();

            this.data = data;
        }

        public validate() {
            if (this.XCenter == undefined || this.YCenter == undefined ||
                this.StartAngle == undefined || this.EndAngle == undefined ||
                this.XRadius == undefined || this.YRadius == undefined ||
                this.Clockwise) {
                throw new TypeError();
            }
        }
    }

    export class PolylineCurve extends Curve {
        private data: any;

        public get PointSet(): GraphicData.Vector3D[] {
            return this.data.P;
        }

        constructor(data: any) {
            super();

            this.data = data;
        }

        public validate() {
            if (this.PointSet == undefined) {
                throw new TypeError();
            }
        }
    }

    export class Revolution {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Rotation(): GraphicData.Rotation {
            return this.data.Rot;
        }

        public get SweepAngle(): number {
            return this.data.SwpA;
        }

        public get SweepRadius(): number {
            return this.data.SwpR;
        }

        public get Capped(): number {
            return this.data.Cpd;
        }

        public get Clockwise(): number {
            return this.data.ClWi;
        }

        public get NumCurves(): any {
            return this.data.Crvs.length;
        }

        public GetCurve(index: number): Curve {
            return (this.data.Crvs[index].Ty == 1) ? new PolylineCurve(this.data.Crvs[index]) : new EllipseCurve(this.data.Crvs[index]);
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Position == undefined || this.Rotation == undefined ||
                this.SweepAngle == undefined || this.SweepRadius == undefined ||
                this.Clockwise == undefined || this.Capped == undefined ||
                this.NumCurves == undefined) {
                throw new TypeError();
            }
        }
    }
    export class Pyramid {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Rotation(): GraphicData.Rotation {
            return this.data.Rot;
        }

        public get StartSize(): GraphicData.Vector2D {
            return this.data.StSi;
        }

        public get EndSize(): GraphicData.Vector2D {
            return this.data.EnSi;
        }

        public get Offset(): GraphicData.Vector2D {
            return this.data.Ofst;
        }

        public get Capped(): number {
            return this.data.Cpd;
        }

        public get Height(): number {
            return this.data.Hgt;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Position == undefined || this.Rotation == undefined ||
                this.StartSize == undefined || this.EndSize == undefined ||
                this.Offset == undefined || this.Capped == undefined) {
                throw new TypeError();
            }
        }
    }

    export class Polyhedron {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Rotation(): GraphicData.Rotation {
            return this.data.Rot;
        }

        public get StartProfile(): GraphicData.Vector3D[] {
            return this.data.StPro;
        }

        public get EndProfile(): GraphicData.Vector3D[] {
            return this.data.EnPro;
        }

        public get Capped(): number {
            return this.data.Cpd;
        }

        public get Clockwise(): number {
            return this.data.ClWi;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Position == undefined || this.Rotation == undefined ||
                this.StartProfile == undefined || this.EndProfile == undefined ||
                this.Capped == undefined || this.Clockwise == undefined) {
                throw new TypeError();
            }
        }
    }

    export class RectTorus {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Rotation(): GraphicData.Rotation {
            return this.data.Rot;
        }

        public get Width(): number {
            return this.data.Wdt;
        }

        public get Height(): number {
            return this.data.Hgt;
        }

        public get Capped(): number {
            return this.data.Cpd;
        }

        public get BendRadius(): number {
            return this.data.BndR;
        }

        public get SweepAngle(): number {
            return this.data.SwpA;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Position == undefined || this.Rotation == undefined ||
                this.Width == undefined || this.Height == undefined ||
                this.BendRadius == undefined || this.Capped == undefined ||
                this.SweepAngle) {
                throw new TypeError();
            }
        }
    }
    export class Torus {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Rotation(): GraphicData.Rotation {
            return this.data.Rot;
        }

        public get Radius(): number {
            return this.data.Ra;
        }

        public get BendRadius(): number {
            return this.data.BndR;
        }

        public get Scale(): number {
            return this.data.Scl;
        }

        public get Capped(): number {
            return this.data.Cpd;
        }

        public get SweepAngle(): number {
            return this.data.SwpA;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Position == undefined ||
                this.Rotation == undefined ||
                this.Radius == undefined ||
                this.BendRadius == undefined ||
                this.Scale == undefined ||
                this.Capped == undefined ||
                this.SweepAngle == undefined) {
                throw new TypeError();
            }
        }
    }
    export class TShape {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Rotation(): GraphicData.Rotation {
            return this.data.Rot;
        }

        public get Scale(): GraphicData.Vector3D {
            return this.data.Scl;
        }

        public get TopThickness(): number {
            return this.data.TpTh;
        }

        public get CenterThickness(): number {
            return this.data.CeTh;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Position == undefined ||
                this.Rotation == undefined ||
                this.Scale == undefined ||
                this.TopThickness == undefined ||
                this.CenterThickness == undefined) {
                throw new TypeError();
            }
        }
    }
    export class UShape {
        private data: any;

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Rotation(): GraphicData.Rotation {
            return this.data.Rot;
        }

        public get Scale(): GraphicData.Vector3D {
            return this.data.Scl;
        }

        public get FlangeThickness(): number {
            return this.data.FlTh;
        }

        public get WebThickness(): number {
            return this.data.WeTh;
        }

        constructor(data: any) {
            this.data = data;
        }

        public validate() {
            if (this.Position == undefined ||
                this.Rotation == undefined ||
                this.Scale == undefined ||
                this.FlangeThickness == undefined ||
                this.WebThickness == undefined) {
                throw new TypeError();
            }
        }
    }

    export class MarkedPoint {

        private data: any;

        constructor(data: any) {
            this.data = data;
        }

        public get Position(): GraphicData.Vector3D {
            return this.data.Pos;
        }

        public get Rotation(): GraphicData.Rotation {
            return this.data.Rot;
        }

        public get LabelPosition(): GraphicData.Vector3D {
            return this.data.LPos;
        }

        public get Caption(): string {
            return this.data.Cap;
        }
        public validate() {
            if (this.Position == undefined ||
                this.Rotation == undefined ||
                this.LabelPosition == undefined ||
                this.Caption == undefined) {
                throw new TypeError();
            }
        }
    }

    export class Label {

        private data: any;

        constructor(data: any) {
            this.data = data;
        }

        public get Position(): GraphicData.Vector2D {
            return this.data.Pos;
        }

        public get Caption(): string {
            return this.data.Cap;
        }

        public get LineColor(): string {
            var col = parseInt(this.data.LnCol);

            return "rgba(" + (col >> 16 & 0xFF) + "," + (col >> 8 & 0xFF) + "," + (col >> 0 & 0xFF) + "," + (col >> 24 & 0xFF) + ")";
        }

        public get LineEnabled(): boolean {
            return this.data.LnEn;
        }

        public get CaptionFont(): MaterialData.Font {
            return new MaterialData.Font(this.data.Fnt.Bold, this.data.Fnt.CharSet, this.data.Fnt.FaceName, this.data.Fnt.Height,
                this.data.Fnt.Italic, this.data.Fnt.Strikeout, this.data.Fnt.Underline);
        }

        public get BackgroundColor(): string {
            var col = parseInt(this.data.BgCol);

            return "rgba(" + (col >> 16 & 0xFF) + "," + (col >> 8 & 0xFF) + "," + (col >> 0 & 0xFF) + "," + (col >> 24 & 0xFF) + ")";
        }

        public get TextColor(): string {
            var col = parseInt(this.data.TCol);

            return "rgba(" + (col >> 16 & 0xFF) + "," + (col >> 8 & 0xFF) + "," + (col >> 0 & 0xFF) + "," + (col >> 24 & 0xFF) + ")";
        }

        public validate() {
            if (this.Position == undefined ||
                this.Caption == undefined ||
                this.LineColor == undefined ||
                this.LineEnabled == undefined ||
                this.CaptionFont == undefined ||
                this.BackgroundColor == undefined ||
                this.TextColor == undefined) {
                throw new TypeError();
            }
        }
    }

    export class Vector3D {
        /// <summary>
        /// Gets or sets the X coordinate of the 3D Vector.
        /// </summary>
        X: number;
        /// <summary>
        /// Gets or sets the Y coordinate of the 3D Vector.
        /// </summary>
        Y: number;
        /// <summary>
        /// Gets or sets the Z coordinate of the 3D Vector.
        /// </summary>
        Z: number;
    }
    export class Vector2D {
        /// <summary>
        /// Gets or sets the X coordinate of the 2D Vector.
        /// </summary>
        X: number;
        /// <summary>
        /// Gets or sets the Y coordinate of the 2D Vector.
        /// </summary>
        Y: number;
    }
    export class Rotation {
        /// <summary>
        /// Gets or sets the X coordinate of the 3D Vector.
        /// </summary>
        X: number;
        /// <summary>
        /// Gets or sets the Y coordinate of the 3D Vector.
        /// </summary>
        Y: number;
        /// <summary>
        /// Gets or sets the Z coordinate of the 3D Vector.
        /// </summary>
        Z: number;
        /// <summary>
        /// Gets or sets the angle of the rotation.
        /// </summary>
        W: number;
    }
}

export namespace MaterialData {
    export class MaterialResults {
        private data: any;

        /// <summary>
        /// Gets the number of materials in the result.
        /// </summary>
        public get DataLength(): number {
            return this.data.length;
        }
        /// <summary>
        /// Gets the type of material as a given index.
        /// </summary>
        /// <param name="index">The index for which the material type will be returned.</param>
        public GetMaterialType(index: number): any {
            return this.data[index].AppearanceType;
        }

        /// <summary>
        /// Gets the material at an index for this result.
        /// </summary>
        /// <param name="index">The index for which the material will be returned.</param>
        public MaterialResult(index: number): Material {
            return new Material(this.data[index]);
        }
        /// <summary>
        /// Gets the marked point material at an index for this result.
        /// </summary>
        /// <param name="index">The index for which the material will be returned.</param>
        public MarkedPointMaterialResult(index: number): MarkedPointMaterial {
            return new MarkedPointMaterial(this.data[index]);
        }

        constructor(data: any) {
            this.data = data;
        }
    }

    export class Material {
        private data: any;

        constructor(data: any) {
            this.data = data;
        }

        /// <summary>
        /// Gets the Id of the material.
        /// </summary>
        public get Id(): string {
            return (this.data.Identity) ? this.data.Identity.ID : this.data.ID;
        }

        /// <summary>
        /// Gets the Name of the material.
        /// </summary>
        public get Name(): string {
            return this.data.Name;
        }

        /// <summary>
        /// Gets the R of the ambient color.
        /// </summary>
        public get AmbientR(): number {

            var col = this.data.AmbientColor;

            return col >> 16 & 0xFF;
        }

        /// <summary>
        /// Gets the G of the ambient color.
        /// </summary>
        public get AmbientG(): number {
            var col = this.data.AmbientColor;

            return col >> 8 & 0xFF;
        }

        /// <summary>
        /// Gets the B of the ambient color.
        /// </summary>
        public get AmbientB(): number {
            var col = this.data.AmbientColor;

            return col >> 0 & 0xFF;
        }

        /// <summary>
        /// Gets the R of the diffuse color.
        /// </summary>
        public get DiffuseR(): number {
            var col = this.data.DiffuseColor;

            return col >> 16 & 0xFF;
        }

        /// <summary>
        /// Gets the G of the diffuse color.
        /// </summary>
        public get DiffuseG(): number {
            var col = this.data.DiffuseColor;

            return col >> 8 & 0xFF;
        }

        /// <summary>
        /// Gets the B of the diffuse color.
        /// </summary>
        public get DiffuseB(): number {
            var col = this.data.DiffuseColor;

            return col >> 0 & 0xFF;
        }

        /// <summary>
        /// Gets the R of the emissive color.
        /// </summary>
        public get EmissiveR(): number {
            var col = this.data.EmissiveColor;

            return col >> 16 & 0xFF;
        }

        /// <summary>
        /// Gets the G of the emissive color.
        /// </summary>
        public get EmissiveG(): number {
            var col = this.data.EmissiveColor;

            return col >> 8 & 0xFF;
        }

        /// <summary>
        /// Gets the B of the emissive color.
        /// </summary>
        public get EmissiveB(): number {
            var col = this.data.EmissiveColor;

            return col >> 0 & 0xFF;
        }

        /// <summary>
        /// Gets the R of the specular color.
        /// </summary>
        public get SpecularR(): number {
            var col = this.data.SpecularColor;

            return col >> 16 & 0xFF;
        }

        /// <summary>
        /// Gets the G of the specular color.
        /// </summary>
        public get SpecularG(): number {
            var col = this.data.SpecularColor;

            return col >> 8 & 0xFF;
        }

        /// <summary>
        /// Gets the B of the specular color.
        /// </summary>
        public get SpecularB(): number {
            var col = this.data.SpecularColor;

            return col >> 0 & 0xFF;
        }

        /// <summary>
        /// Gets the shininess of the material.
        /// </summary>
        public get Shininess(): number {
            return this.data.Shininess;
        }

        /// <summary>
        /// Gets the transparency of the material.
        /// </summary>
        public get Transparency(): number {
            return this.data.Transparency;
        }
    }

    export class MarkedPointMaterial {
        private lineWidth: number;
        private lineColor: string;
        private captionTextColor: string;
        private captionFont: string;
        private backgroundColor: string;
        private tagShape: Enumerations.AnnotationLabelShape;

        private data: any;

        constructor(data: any) {
            this.data = data;
        }

        /// <summary>
        /// Gets the Id of the material.
        /// </summary>
        public get Id(): string {
            return (this.data.Identity) ? this.data.Identity.ID : this.data.ID;
        }

        public get TagShape(): Enumerations.AnnotationLabelShape {
            return this.data.TagShapeType;
        }

        public get MarkerShape(): Enumerations.MarkedPointPrimitiveShape {
            return Enumerations.MarkedPointPrimitiveShape.SPHERE;
        }

        public get MarkerObjectAppearanceId(): string {
            return (this.data.MarkerObjectAppearance.Identity) ? this.data.MarkerObjectAppearance.Identity.ID : this.data.MarkerObjectAppearance.ID;
        }

        public get BackgroundColor(): string {

            var col = parseInt(this.data.TagBackgroundColor);

            return "rgba(" + (col >> 16 & 0xFF) + "," + (col >> 8 & 0xFF) + "," + (col >> 0 & 0xFF) + "," + (col >> 24 & 0xFF) / 255 + ")";
        }

        public get CaptionFont(): Font {
            return new Font(this.data.TagCaptionFont.Bold, this.data.TagCaptionFont.CharSet, this.data.TagCaptionFont.FaceName, this.data.TagCaptionFont.Height,
                this.data.TagCaptionFont.Italic, this.data.TagCaptionFont.Strikeout, this.data.TagCaptionFont.Underline);
        }

        public get CaptionTextColor(): string {
            var col = parseInt(this.data.TagCaptionTextColor);

            return "rgba(" + (col >> 16 & 0xFF) + "," + (col >> 8 & 0xFF) + "," + (col >> 0 & 0xFF) + "," + (col >> 24 & 0xFF) + ")";
        }

        public get LineWidth(): number {
            return this.data.TagLineWidth;
        }

        public get LineColor(): string {
            var col = parseInt(this.data.TagLineColor);

            return "rgba(" + (col >> 16 & 0xFF) + "," + (col >> 8 & 0xFF) + "," + (col >> 0 & 0xFF) + "," + (col >> 24 & 0xFF) + ")";
        }

        public get MarkerSize(): number {
            return this.data.MarkerSize;
        }

        public get TagIsVisible(): boolean {
            return this.data.TagIsVisible;
        }
    }

    export class Font {

        private _bold: boolean;
        private _charset: string;
        private _faceName: string;
        private _height: number;
        private _italic: boolean;
        private _strikeout: boolean;
        private _underline: boolean;


        public get Bold(): boolean {
            return this._bold;
        }

        public get Charset(): string {
            return this._charset;
        }

        public get FaceName(): string {
            return this._faceName;
        }

        public get Height(): number {
            return this._height;
        }

        public get Italic(): boolean {
            return this._italic;
        }

        public get Strikeout(): boolean {
            return this._strikeout;
        }
        public get Underline(): boolean {
            return this._underline;
        }

        constructor(bold: boolean, charSet: string, faceName: string, height: number, italic: boolean, strikeout: boolean, underline: boolean) {
            this._bold = bold;
            this._charset = charSet;
            this._faceName = faceName;
            this._height = height;
            this._italic = italic;
            this._strikeout = strikeout;
            this._underline = underline;
        }
    }
}
